<div class="cx_brandColorBar__container">
  <span class="app_backgroundColor_blue-light"></span>
  <span class="app_backgroundColor_blue"></span>
  <span class="app_backgroundColor_blue-dark"></span>
  <span class="app_backgroundColor_orange-light"></span>
  <span class="app_backgroundColor_orange-dark"></span>
</div>
